import React from 'react'
import PropTypes from 'prop-types'
import { sharedT } from '../../helpers/i18n'

// `role="status"` so a screen-reader user hears the load, which a silent swap would not tell them.

const LoadingState = ({ label, className = '' }) => (
  <div className={[ 'gl-load-msg', className ].filter(Boolean).join(' ')} role="status">
    {label || sharedT('loading')}
  </div>
)

LoadingState.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
}

export default LoadingState
